/* eslint-disable no-useless-escape */
/* eslint-disable spaced-comment */
export const urlRegex =
	/(^((?!-)(?=^.{4,253}$)(https?:\/\/)?(www)?([a-zA-Z0-9-]{0,62})+(\.[a-zA-Z0-9;,^\/?.:@&=+$%\-_!~*'()#{}]{2,183})+$))/;

export const regexHasForbiddenCharTest =
	/^(\s)|^(con|prn|aux|nul|com[0-9]|lpt[0-9])$|([<>:"/\\|?*])|(\.|\s)$/i;

export const regexIsValidPathTest =
	/^(?=[^ .])(?: (?! )|[/](?![/])|[-!'()*.0-9A-Z_a-z])*(?<![ .])$|([<>:"/\\|?*])|(\.|\s)$/;

export const regexIsImgTestExpanded =
	/(\/*).+\.(png|jpg|jpeg|gif|bmp|pdf|tiff|webm)$/i;
export const regexIsImgTest = /(\/*).+\.(png|jpg|jpeg)$/i;

// Adding support for video file types
export const regexIsVideoTest = /(\/*).+\.(mp4|mov)$/i;
export const regexIsMediaTest = /(\/*).+\.(png|jpg|jpeg|mp4|mov)$/i;

/**
 * The single client-side email rule for bay-ui and its consumers (monday
 * 13197296743). Every email check in a bay-ui component imports this; a
 * consumer that passes its own pattern still wins.
 *
 * Anchored, so trailing text is rejected rather than matched in the middle of a
 * longer string. Case-insensitive by character class rather than the `i` flag,
 * because callers read `.source` when handing the pattern to an HTML `pattern`
 * attribute, where flags are lost. The domain ending is `{2,}` and deliberately
 * uncapped: the older `{2,4}` copies rejected .homes, .realtor and .realestate.
 *
 * Surrounding whitespace is tolerated so a pasted address is not rejected for
 * the spaces that came with it. Only the outside — a space anywhere inside the
 * address still fails. Validation accepting it does not mean storing it; trim
 * before saving.
 */
export const emailRegex =
	/^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*$/;
